import { useLoader } from '@react-three/fiber'
import { useEffect, useRef } from 'react'
import * as THREE from 'three'

type ImageViewerType = {
  src: string
  onLoaded: () => void
}

export const ImageViewer = ({ src, onLoaded }: ImageViewerType) => {
  const refMesh = useRef<THREE.Mesh>(null)
  const refGeometry = useRef<THREE.SphereGeometry>(null)
  const refMaterial = useRef<THREE.MeshBasicMaterial>(null)

  const imageTexture = useLoader(THREE.TextureLoader, src, (loader: THREE.Loader) => {
    loader.crossOrigin = 'use-credentials'
    loader.manager.onLoad = () => {
      onLoaded()
      loader.manager.onLoad = () => {}
    }
  })
  imageTexture.colorSpace = THREE.SRGBColorSpace
  imageTexture.mapping = THREE.EquirectangularRefractionMapping
  imageTexture.minFilter = THREE.LinearFilter
  imageTexture.magFilter = THREE.LinearFilter

  useEffect(() => {
    return () => {
      if (refGeometry.current) {
        refGeometry.current.dispose()
      }
      if (refMaterial.current) {
        refMaterial.current.dispose()
      }
      if (refMesh.current) {
        refMesh.current.remove()
      }
    }
  }, [])

  useEffect(() => {
    return () => {
      if (imageTexture) {
        imageTexture.dispose()
      }
    }
  }, [imageTexture])

  return (
    <mesh ref={refMesh} position={[0, 0, 0]} rotation-y={-Math.PI / 2} scale={[-1, 1, 1]}>
      <sphereGeometry ref={refGeometry} args={[1000, 130, 65]} />
      <meshBasicMaterial ref={refMaterial} side={THREE.BackSide} map={imageTexture} depthWrite={false} />
    </mesh>
  )
}
